import React, { useState, useEffect } from "react";
import { useAppDispatch } from "../Core/store.hooks";
import CustomerGridWidget from "./CustomerGridWidget";
import RecentCustomerGridWidget from "./RecentCustomerGridWidget";
import DashboardContainer from "../Common/Components/DashboardContainer";
import Filters from "./Filter";
import { toggleSidebar } from "../Common/Slices/SidebarSlice";
import { AuthApi } from "../Core/api";

const Search = () => {
  const dispatch = useAppDispatch();
  const positionData = [
    { col: 1, colSpan: 6, rowSpan: 5 },
    { col: 1, colSpan: 6, rowSpan: 12 },
    { col: 1, colSpan: 6, rowSpan: 12 },
  ];

  useEffect(() => {
    dispatch<any>(toggleSidebar({ isOpen: true }));
  }, []);

    useEffect(() => { AuthApi.logUserEvent("Search","") }, []);
  const sidebarItems: { title: string; item: any; expanded: boolean }[] = [
    {
      title: "Search Filters",
      item: <Filters gridType="Customer" />,
      expanded: true,
    },
  ];
  const getDefaultWidgets = () => {
    return [
      <RecentCustomerGridWidget header="Recent Selected Customers" id="2" />,
      <CustomerGridWidget header=" Customer List" id="1" />,
    ];
  };
  const defaultWidgets = getDefaultWidgets();

  return (
    <DashboardContainer
      sidebarItems={sidebarItems}
      positionData={positionData}
      defaultWidgets={defaultWidgets}
      addRemove={false}
      savable={false}
    />
  );
};

export default Search;
